import { createWebHashHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/zy/home",
  },
  {
    path: "/zy",
    name: "layout",
    component: () => import("../components/layout/index.vue"),
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/home/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "team",
        name: "team",
        component: () => import("../views/introduce/team.vue"),
        meta: {
          title: "集团主席",
        },
      },
      {
        path: "introduce",
        name: "introduce",
        component: () => import("../views/introduce/introduce.vue"),
        meta: {
          title: "企业简介",
        },
      },
      {
        path: "minerals",
        name: "minerals",
        component: () => import("../views/business/minerals.vue"),
        meta: {
          title: "矿产及能源",
        },
      },
      {
        path: "property",
        name: "property",
        component: () => import("../views/business/property.vue"),
        meta: {
          title: "不动产及物业",
        },
      },
      {
        path: "invest",
        name: "invest",
        component: () => import("../views/business/invest.vue"),
        meta: {
          title: "对外投资",
        },
      },
      {
        path: "welfare",
        name: "welfare",
        component: () => import("../views/welfare/index.vue"),
        meta: {
          title: "公益事业",
        },
      },
      {
        path: "join",
        name: "join",
        component: () => import("../views/join/index.vue"),
        meta: {
          title: "加入中誉",
        },
      },
      {
        path: "job",
        name: "job",
        component: () => import("../views/join/job.vue"),
        meta: {
          title: "岗位",
        },
      },
      {
        path: "about",
        name: "about",
        component: () => import("../views/about/index.vue"),
        meta: {
          title: "联系我们",
        },
      },
    ],
  },
  // {
  //     path: '*',
  //     redirect: '/404'
  // },
  // {
  //     path: '/403',
  //     component: () => import(/* webpackChunkName: "403" */ '../components/403.vue'),
  //     meta: {
  //         title: '403'
  //     }
  // },
  // {
  //     path: '/404',
  //     component: () => import(/* webpackChunkName: "404" */ '../components/404.vue'),
  //     meta: {
  //         title: '404'
  //     }
  // }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
